import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import { styled } from "styled-components";
import Link from "../../components/Link";
import sunnyLogo from "../../images/sunny-logo.svg";

const StlHeader = styled.header`
  background-color: white;
  height: 78px;
  padding: 12px 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05); /* mimic shadow-header */
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;

  @media (min-width: 768px) {
    padding: 18px 40px;
  }
`;

const StlLogoLink = styled.a`
  display: flex;
  align-self: center;
  width: auto;
`;

const StlLogoImage = styled.img`
  display: block;
  width: 146px;

  @media (min-width: 768px) {
    width: 165px;
  }
`;

const Navigation = () => {
  const dispatch = useDispatch();

  const data = useSelector((state) =>
    get(state, "prismic.navigation.data", false),
  );

  useEffect(() => {
    dispatch({
      type: "PRISMIC_LOAD_SINGLE_PAGE",
      key: "navigation",
    });
  }, [dispatch]);
  return (
    <StlHeader data-state="Illinois">
      <StlLogoLink href="/">
        <StlLogoImage
          src={get(data, "logo.url") || sunnyLogo}
          alt="Sunnyside Logo"
        />
      </StlLogoLink>

      <Link
        className="header-button"
        target="_blank"
        url={get(data, "shop_link.url")}
      >
        {get(data, "link_text")}
      </Link>
    </StlHeader>
  );
};

export default Navigation;
